"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // (C) 2007-2018 GoodData Corporation

var routes_1 = require("./routes");

var LogsModule =
/** @class */
function () {
  function LogsModule(xhr) {
    this.xhr = xhr;
  }

  LogsModule.prototype.getLogs = function (contractId, dataProductId, domainId, segmentId) {
    return this.xhr.get(routes_1.interpolate(routes_1.CONTRACT_DATA_PRODUCT_DOMAIN_SEGMENT_LOG, {
      contractId: contractId,
      dataProductId: dataProductId,
      domainId: domainId,
      segmentId: segmentId
    })).then(function (data) {
      return data.logs.map(function (item) {
        return item.log;
      });
    });
  };

  return LogsModule;
}();

exports.LogsModule = LogsModule;